module.exports = __WEBPACK_EXTERNAL_MODULE_8__;


//////////////////
// WEBPACK FOOTER
// external "underscore"
// module id = 8
// module chunks = 0 1 2 3